import {Component, Input, OnInit} from '@angular/core';

@Component({
    selector: 'ecp-ant-tags',
    templateUrl: './ecp-ant-tags.component.html',
    styleUrls: ['./ecp-ant-tags.component.css']
})
export class EcpAntTagsComponent implements OnInit {
    @Input() styleType = 'style1';
    @Input() contentPadding = false;
    @Input() ecpStyle = {};

    constructor() {
    }

    ngOnInit() {
    }



}
